import React from "react";
import App from "./App";
import { hydrate, render } from "react-dom";
import Modal from "react-modal";

Modal.setAppElement("#root");

const rootElement = document.getElementById("root");
if (rootElement.hasChildNodes()) {
  hydrate(<App />, rootElement);
} else {
  render(<App />, rootElement);
}
